import React from 'react';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale } from 'chart.js';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend
);


const SleepQualityChart = ({ data }) => {
  const chartData = {
    labels: data.map(journal => moment(journal.date).format('DD/MM/YYYY')),
    datasets: [{
      label: 'Sleep Quality',
      data: data.map(journal => {
        switch (journal.sleep_quality) {
          case 'Super bad': return 1;
          case 'Bad with interruptions': return 2;
          case 'Restless': return 3;
          case 'Normal': return 4;
          case 'Very deep': return 5;
          default: return null;
        }
      }),
      fill: false,
      borderColor: 'rgb(0, 128, 128)',
      tension: 0.1,
       cubicInterpolationMode: 'monotone'
    }],
  };

  const options = {
    spanGaps: true,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: 'Sleep Quality',
        },
        min: 1,
        max: 5,
        ticks: {
          callback: function(value, index, values) {
            switch (value) {
              case 1: return 'Super bad';
              case 2: return 'Bad with interruptions';
              case 3: return 'Restless';
              case 4: return 'Normal';
              case 5: return 'Very Deep';
              default: return '';
            }
          }
        }
      },
      x: {
        title: {
          display: true,
          text: 'Date',
        }
      }
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow-lg">
      <Line data={chartData} options={options} />
    </div>
  );
};

export default SleepQualityChart;
